module.exports = __webpack_public_path__ + "img/po-article2-c2.69928949.png";